import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getChannelRules = (params) => httpClient.get(`${ENDPOINT_API.CHANNEL_ROLES}`, { params });
const getChannelRule = (id) => httpClient.get(`${ENDPOINT_API.CHANNEL_ROLES}/${id}`);
const postChannelRule = (params) => httpClient.post(`${ENDPOINT_API.CHANNEL_ROLES}`, params);
const putChannelRule = (id, params) => httpClient.put(`${ENDPOINT_API.CHANNEL_ROLES}/${id}`, params);
const deleteChannelRule = (id) => httpClient.delete(`${ENDPOINT_API.CHANNEL_ROLES}/${id}`);

export {
	getChannelRules,
	getChannelRule,
	postChannelRule,
	putChannelRule,
	deleteChannelRule,
};
